module.exports = __webpack_public_path__ + "static/media/li.9e40c74a.svg";